import { LeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "../Interactive.module.scss";
import i18n from "i18next";
import { cssGrayscale } from "utils/utils";

const Back = ({
  onClick,
  text = i18n.t("widget.back"),
  contrastGrayscale,
}: {
  text?: string;
  onClick?: () => void;
  contrastGrayscale?: number;
}) => (
  <Button
    onClick={onClick}
    type="text"
    className={styles.back}
    style={
      !onClick
        ? { display: "none", color: cssGrayscale(contrastGrayscale) }
        : { color: cssGrayscale(contrastGrayscale) }
    }
  >
    <LeftOutlined />
    {text}
  </Button>
);

export default Back;
